import { cn } from '@/utils/styles';

import { ConnectionIcon } from '@/components/icons/ConnectionIcon';

interface ConnectionCardProps {
  name: string;
  noOfConnections: number | null;
  connectionType: string;
  connectionTypeColor: string;
  onClick?: () => void;
}

export const ConnectionCard: React.FC<ConnectionCardProps> = ({
  name,
  noOfConnections,
  connectionType,
  connectionTypeColor,
  onClick,
}) => {

  const connectionData = noOfConnections
    ? `${noOfConnections} connections`
    : 'No connections';

  return (
    <button
      onClick={onClick}
      className={cn(
        'p-5 rounded-lg  shadow-md bg-[#42434D73] hover:shadow-lg transition-shadow text-left w-full',
      )}
    >
      <div>
        <div className="flex justify-between w-full">
          {/* Connection Type */}
          <div className='w-3/5 flex justify-start mr-3'>
            <div
              className={cn('dark inline-block px-2 py-1 rounded bg-black')}
              style={{
                color: connectionTypeColor
              }}
            >
              <p className="typography-caption1 line-clamp-1">
                <abbr className="no-underline" title={connectionType}>
                  {connectionType}
                </abbr>
              </p>
            </div>
          </div>

          <div className="flex w-2/5 justify-end items-center">
            <p className="typography-body text-secondary mr-1 whitespace-nowrap min-w-16 truncate">
              <abbr className="no-underline" title={connectionData}>
                {connectionData}
              </abbr>
            </p>
            <ConnectionIcon className="!size-6" />
          </div>
        </div>
        <h3
          className="dark typography-title text-primary mt-4 truncate whitespace-nowrap"
          title={name}
        >
          {name}
        </h3>
      </div>
    </button>
  );
};
